import {
  ActionIcon,
  Box,
  Button,
  Group,
  Input,
  Popover,
  Select,
  Text,
  Title,
} from "@mantine/core";

import ListToggleControl, {
  ListViewOption,
} from "core/components/listToggle/listToggleControl";

import {
  createTalent,
  fetchTalents,
  getTalentsSuccess,
  selectTalent,
  selectTalents,
  setTalentFilter,
  updateTalent,
  updateTalentSuccess,
} from "modules/Talent/talentSlice";
import { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FilterButton, TalentFilterPanel } from "core/components";

// import TalentEdit from '../talent/TalentEdit';
import { IconSearch, IconX } from "@tabler/icons-react";
// import Dashboard from './features/components/Dashboard';
import { logger } from "utils/logger";
import { TalentStatusTypes } from "core/models/TalentModel";
import { isDate } from "moment";
import { AppConstants, TalentActions } from "utils/constants";
import { setPreviousRoute } from "app/appSlice";
import { TalentEventType } from "core/models/TalentModel";
// import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import { setDisplayPrefs } from "modules/Talent/talentSlice";
import { pluralize } from "utils/helper";
import TalentGridLayout from "./TalentGridLayout";
import TalentList from "./TalentList";
import { createColumnHelper } from "@tanstack/react-table";
import ResolverImage from "core/components/resolverImage/ResolverImage";

const Talents = ({
  user,
  talent,
  talents,
  selectedTalents,
  success,
  error,
  setTalentFilter,
  talentFilter,
  displayPrefs,
  setDisplayPrefs,
}) => {
  const dispatch = useDispatch();
  const [filterOpen, setFilterOpen] = useState(false);
  const [listView, setListView] = useState(displayPrefs.mediaDisplayType);
  const navigate = useNavigate();
  const location = useLocation();
  // const [selectedItems, setSelectedItems] = useState(selectedTalents);
  const [filterCount, setFilterCount] = useState(0);
  const [talentData, setTalentData] = useState([]);
  const [filterItems, setFilterItems] = useState(talentFilter);
  // const [talentModalOpen, setTalentModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const selectAllMenu = (
    <div>
      {/* <Button variant='default' onClick={(e) => onMenuItemClick(TalentActions.ARCHIVE)}>
                Archive
            </Button> */}
      {/* <Button variant='default' onClick={(e) => onMenuItemClick(e)}>Add to Talent</Button> */}
      <Button variant="default" onClick={(e) => onSelectAll(e)}>
        Deselect All
      </Button>
    </div>
  );

  useEffect(() => {
    if (success) {
      logger.log(success);
      switch (success.type) {
        // case bulkUpdateTalentsSuccess.toString():
        case updateTalentSuccess.toString(): {
          dispatch(fetchTalents());
          break;
        }
        case getTalentsSuccess.toString(): {
          setIsLoading(false);
          break;
        }
        default: {
          break;
        }
      }
    }
  }, [success]);

  /**
   * Handles the list toggle display
   * @param {*} val
   */
  const listToggleHandler = (val) => {
    navigate({ search: `?displayType=${val}` });
  };

  const filterTalents = useCallback(() => {

    var data = talents?.filter((sample) => {
      var match = true;
      // filter by brand
      if (talentFilter.agency && talentFilter.agency.length) {
        match = talentFilter.agency.indexOf(sample.agency) > -1 ? true : false;
      }

      if (talentFilter.gender && talentFilter.gender.length && match) {
        match = talentFilter.gender.indexOf(sample.gender) > -1 ? true : false;
      }

      if (talentFilter.category && talentFilter.category.length && match) {
        match = talentFilter.category.indexOf(sample.category) > -1 ? true : false;
      }

      // if (talentFilter.seasons && talentFilter.seasons.length && match) {
      //     match = talentFilter.seasons.indexOf(sample.season) > -1 ? true : false;
      // }

      // if (talentFilter.tags && talentFilter.tags.length && match) {
      //     var tag;
      //     for (let i = 0; i < talentFilter.tags.length; i++) {
      //         tag = sample.tags?.indexOf(talentFilter.tags[i]) > -1 ? true : false;
      //         if (tag) {
      //             break;
      //         }
      //     }
      //     match = tag ? true : false;
      // }

      if (talentFilter.status && talentFilter.status.length && match) {
        match = talentFilter.status.indexOf(sample.status) > -1 ? true : false;
      }

      if (talentFilter.age && talentFilter.age.length && match) {
        match =
          parseInt(sample.age) >= talentFilter.age[0] &&
          parseInt(sample.age) <= talentFilter.age[1];
      }

      if (talentFilter.teams && talentFilter.teams.length && match) {
        var person;
        for (let i = 0; i < talentFilter.teams.length; i++) {
          person = sample.team.find(
            (samplePerson) => samplePerson.name === talentFilter.teams[i]
          );
          if (person) {
            break;
          }
        }
        match = person ? true : false;
      }

      // Deadline filter dates
      // if (talentFilter.dueDateStart && talentFilter.dueDateEnd && match) {
      //     match = sample.deadline >= talentFilter.dueDateStart && sample.deadline <= talentFilter.dueDateEnd ? true : false;
      // } else if (talentFilter.dueDateStart && talentFilter.dueDateEnd === '' && match) {
      //     match = sample.deadline >= talentFilter.dueDateStart ? true : false;
      // } else if (talentFilter.dueDateEnd && talentFilter.dueDateStart === '' && match) {
      //     match = sample.deadline <= talentFilter.dueDateEnd ? true : false;
      // }

      // // shootdate filter dates
      // if (talentFilter.shootDateStart && talentFilter.shootDateEnd && match) {
      //     match = sample.shootDate >= talentFilter.shootDateStart && sample.shootDate <= talentFilter.shootDateEnd ? true : false;
      // } else if (talentFilter.shootDateStart && talentFilter.shootDateEnd === '' && match) {
      //     match = sample.shootDate >= talentFilter.shootDateStart ? true : false;
      // } else if (talentFilter.shootDateEnd && talentFilter.shootDateStart === '' && match) {
      //     match = sample.shootDate <= talentFilter.shootDateEnd ? true : false;
      // }

      if (talentFilter.keyword && talentFilter.keyword.length && match) {
        match =
          sample.fullName
            .toLowerCase()
            .indexOf(talentFilter.keyword.toLowerCase()) > -1
            ? true
            : false;
      }

      return match;
    });

    if (talentFilter.groupBy && (displayPrefs && displayPrefs.mediaDisplayType === ListViewOption.GRID)) {
      var uniq = [...new Set(Object.keys(data).map((e) => data[e][talentFilter.groupBy]))];
      // create the group by items
      var groupedData = uniq.map((group) => {
          var subRows = data.filter((val) => val[talentFilter.groupBy] === group);
          return { type: 'group', name: group, subRows, id: group };
      });
      data = groupedData;
  }

    if (data) setTalentData(data);


  }, [
    talentFilter.categories,
    talentFilter.keyword,
    talents,
    talentFilter.tags,
    talentFilter.status,
    talentFilter.groupBy,
    displayPrefs
  ]);

  /**
   * Effect to fetch the talents
   */
  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      dispatch(fetchTalents());
    }, 100);
  }, [dispatch]);

  useEffect(() => {
    //setTalentData(talents);

    // set the brands/season/category
    var brands = {};
    var categories = {};
    var seasons = {};
    var teams = {};
    var statuses = {};
    var tags = {};
    var departments = {};
    var agencies = {};
    var genders = {};

    talents?.forEach((item, idx) => {
      brands[item.facet_brand] = item;
      categories[item.category] = item;
      seasons[item.season] = item;
      statuses[item.status] = item;
      tags[item.tags] = item;
      departments[item.department] = item;
      agencies[item.agency] = item;
      genders[item.gender] = item;

      if (item.team) {
        item.team.forEach((person) => {
          teams[person.name] = person;
        });
      }
    });

    setFilterItems({
      brands,
      categories,
      seasons,
      teams,
      statuses,
      tags,
      departments,
      agencies,
      genders,
    });

    filterTalents();
  }, [talents, filterTalents]);

  /**
   * Effect to handle location change
   */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let displayType = params.get("displayType");

    // if display type changes
    // if (displayType && displayType !== ListViewOption.GRID) {
    //     displayType = ListViewOption.LIST;
    // }

    if (displayType) {
      // setListView(displayType);
      setDisplayPrefs({ ...displayPrefs, mediaDisplayType: displayType });
    }
  }, [location]);

  const onItemClick = (item) => {
    // we need to select the current sample
    dispatch(selectTalent(item));

    logger.log(item);

    // update the route
    // navigate(`/talent/${item.id}`);
  };

  // const onItemSelected = (e, item, selected) => {
  //     const rows = tableProps.rows;
  //     logger.log(item, selectedTalents);
  //     var items = [...selectedTalents];

  //     // call general helper to select items
  //     // selectItems(
  //     //     e,
  //     //     item,
  //     //     selected,
  //     //     rows.map((val) => val.original),
  //     //     items,

  //     // );

  //     if (e.metaKey) {
  //         // if command held down we add the item to the array
  //         // if it's not yet selected.
  //         const obj = selectedTalents.find((image) => image.id === item.id);
  //         // if the object is already selected then we unselect it
  //         if (obj) {
  //             //items  = [...selectedItems];
  //             items = _.remove([...selectedTalents], (image) => {
  //                 return image.id !== item.id;
  //             });
  //         } else {
  //             items = [...selectedTalents, item];
  //         }
  //     } else if (e.shiftKey) {
  //         // if shift key we push all items from the last selected item
  //         // get the index of the last element selected.
  //         let lastObj = selectedTalents ? selectedTalents[selectedTalents.length - 1] : null;
  //         if (lastObj) {
  //             var dataToFilter = talents;
  //             if (talentFilter.groupBy && talentFilter.groupBy.length) {
  //                 // dataToFilter = data.map(data => data.original);
  //                 dataToFilter = _.flatMap(rows, 'subRows');
  //             }
  //             let lastIdx = _.findIndex(dataToFilter, function (o) {
  //                 return o.id === lastObj.id;
  //             });
  //             let currIdx = _.findIndex(dataToFilter, function (o) {
  //                 return o.id === item.id;
  //             });
  //             let newItems = [...dataToFilter.slice(lastIdx + 1, currIdx + 1)];
  //             items = _.concat(selectedTalents, newItems);
  //         }
  //     } else {
  //         items = [item];
  //         // setSelectedItem({ ...val });

  //         // searchParams.set('captureId',data.captureId);
  //         // setSearchParams(searchParams);
  //     }

  //     // setSelectedItems(items);

  //     dispatch(selectTalents(items));
  // };

  const onSelectAll = () => {
    // if there are items selected remove them
    if (selectedTalents.length) {
      //setSelectedItems([])
      dispatch(selectTalents([]));
    } else {
      //setSelectedItems([...elements])
      dispatch(selectTalents([...talentData]));
    }
  };

  const onMenuItemClick = (e) => {
    switch (e) {
      // case SampleEventType.SAMPLE_BUILD_OUTFIT: {
      //     navigate(`/talents/create`);
      //     break;
      // }
      // case TalentActions.ARCHIVE: {
      //     // loop over the selected items and archive them
      //     const payload = selectedTalents.map(val => {
      //         const item = talents.find(o => o.id === val.id);
      //         return ({...item,status:TalentStatusTypes.ARCHIVE})
      //     })
      //     dispatch(bulkUpdateTalents(payload,user))
      //     break;
      // }
      default: {
        break;
      }
    }
  };

  const setFilterVars = (vals) => {
    logger.log(vals, " FILTER VALS");
    setTalentFilter(vals);
  };

  useEffect(() => {
    // filter the data.
    filterTalents();
  }, [filterTalents]);

  const getFilterCount = (val) => {
    var count = 0;
    const ignoreKeys = ['status', 'groupBy'];
    Object.entries(val).forEach(([key, value]) => {
        if(!value)return;
        if (!isDate(value) && value.length && ignoreKeys.indexOf(key) === -1) {
            ++count;
        } else if (isDate(value)) {
            ++count;
        }
    });

    return count;
};

  useEffect(() => {
    const count = getFilterCount(talentFilter);
    setFilterCount(count);
  }, [talentFilter]);

  const onClearClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopPropagation();

    setTalentFilter({
      keyword: "",
      age: [],
      gender: [],
      agency: [],
      location: [],
      status: [],
      groupBy: "",
    });

    logger.log("CLEAR CLICK", e);
  };

  const filterButtonHandler = (e) => {
    logger.log("BUTTON CLICK", e, e.nativeEvent);
    setFilterOpen((o) => !o);
  };

  const onCreateTalentSubmit = (vals) => {
    logger.log("onCreateTalentSumit", vals);
    dispatch(createTalent(vals, user));
  };

  const onListMenuClick = (e, data) => {
    // we want to store the previous nav state so we can return if we need to.
    const tmpLoc = `${location.pathname}/${location.search}`;
    setPreviousRoute(tmpLoc);

    switch (e.type) {
      case TalentActions.ARCHIVE: {
        // loop over the selected items and archive them
        dispatch(
          updateTalent(
            {
              ...data,
              status:
                data.status === TalentStatusTypes.ARCHIVE
                  ? TalentStatusTypes.ACTIVE
                  : TalentStatusTypes.ARCHIVE,
            },
            user
          )
        );
        break;
      }
      case TalentEventType.SESSION_VIEW: {
        navigate(`/talents/${data.talentId}`);
        break;
      }

      default: {
        break;
      }
    }
  };

  // const tableProps = useTable(
  //     {
  //         columns,
  //         data: talentData,

  //         initialState: {
  //             pageIndex: 0,
  //             pageSize: AppConstants.defaultPaginationSize,
  //             globalFilter: null,
  //             sortBy: [
  //                 // {
  //                 //     id: columns[0].accessor,
  //                 //     desc: false,
  //                 // },
  //             ],
  //         },
  //     },

  //     useFilters,
  //     useGlobalFilter, // useGlobalFilter!
  //     useSortBy,
  //     usePagination,
  // );

  return (
    <Box style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Group
        className="main-container-header"
        justify="space-between"
        align="center"
      >
        <Title order={3} lh={"lg"}>
          Talent
        </Title>
        {/* <Button onClick={() => onCreateClick()}>Create Talent</Button> */}
      </Group>

      <Group
        className="container-action-bar"
        style={{ width: "100%" }}
        justify="space-between"
        height={"100%"}
        py="xs"
      >
        <Group>
          {/* <CheckboxDropdown selectedItems={selectedTalents} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} /> */}
          <Input
            leftSection={<IconSearch size={AppConstants.ICON_SIZE} />}
            style={{ width: "300px" }}
            value={talentFilter.keyword}
            onChange={(e) =>
              setTalentFilter({
                ...talentFilter,
                keyword: e.currentTarget.value,
              })
            }
            placeholder={`Search across ${talents.length} ${pluralize(
              "Record",
              talents.length
            )}`}
            rightSectionPointerEvents="all"
            rightSection={
              <ActionIcon
                variant="transparent"
                onClick={() =>
                  setTalentFilter({
                    ...talentFilter,
                    keyword: "",
                  })
                }
              >
                {talentFilter.keyword.length ? <IconX size={14} /> : null}
              </ActionIcon>
            }
          />

          <Text size="sm">
            Total{" "}
            <strong>
              {talentData?.length} of {talents?.length}
            </strong>{" "}
          </Text>
        </Group>

        <Group>
          {/* <Checkbox
                        label='Include Archived'
                        value={talentFilter.status}
                        onChange={(event) => {
                            setFilterVars({ ...talentFilter, status: event.target.checked ? [] : [TalentStatusTypes.ACTIVE] });
                        }}
                    /> */}

          <Popover
            shadow="sm"
            opened={filterOpen}
            onClose={() => setFilterOpen(false)}
            width={600}
            position="bottom"
            withArrow
            closeOnClickOutside={true}
          >
            <Popover.Target>
              <div>
                <FilterButton
                  onClick={filterButtonHandler}
                  onClear={onClearClick}
                  count={filterCount}
                />
              </div>
            </Popover.Target>
            <Popover.Dropdown>
              <div style={{ display: "flex" }}>
                <TalentFilterPanel
                  filter={talentFilter}
                  onCancel={() => setFilterOpen(false)}
                  onApply={(vals) => {
                    setFilterVars(vals);
                    setFilterOpen(false);
                  }}
                  filterItems={filterItems}
                />
              </div>
            </Popover.Dropdown>
          </Popover>

          {/* <Select
                placeholder="Filter By All"
                data={[
                  { value: '', label: 'Show All' },
                  { value: 'sku', label: 'Filter by SKU' },
                  { value: 'location', label: 'Filter by Location' },
                  { value: 'status', label: 'Filter by Status' },
                ]}
              /> */}

          {/* <Select
            placeholder='Sort By'
            data={[
              { value: 'sku', label: 'Sort by SKU' },
              { value: 'desc', label: 'Sort by Description' },
              { value: 'location', label: 'Sort by Location' },
              { value: 'status', label: 'Sort by Status' },
            ]}
          /> */}
          <Select
            placeholder="Group By"
            value={talentFilter.groupBy}
            clearable={true}
            onChange={(val) =>
              setTalentFilter({
                ...talentFilter,
                groupBy: val,
              })
            }
            data={[
              { value: "", label: "No Group" },
              {
                value: "category",
                label: "Group by Category",
              },
              {
                value: "agency",
                label: "Group by Agency",
              },
              {
                value: "gender",
                label: "Group by Gender",
              },
            ]}
          />

          <ListToggleControl
            value={displayPrefs.mediaDisplayType}
            onChange={(val) => listToggleHandler(val)}
          />
        </Group>
      </Group>

      {/* <ScrollArea style={{height:500}} > */}
      <Box
        className={
          talentFilter.groupBy && talentFilter.groupBy.length
            ? "main-container-content show-data-grouped body-panels"
            : "main-container-content show-data-grouped-hidden body-panels"
        }
        style={{ flex: 1, marginBottom: 33, flex: 1, overflow: "hidden" }}
      >
        {displayPrefs.mediaDisplayType === ListViewOption.LIST ? (
          <div className="table-wrapper" style={{ position: "relative" }}>
            <TalentList
              data={talentData}
              onItemClick={onItemClick}
              // onItemSelected={onItemSelected}
              selectedItems={selectedTalents}
              isLoading={isLoading}
              loading={isLoading}
              originalData={talents}
              // onItemClick={onItemClick}
              onMenuItemClick={onMenuItemClick}
              // onItemSelected={onItemSelected}
              // selectedItems={selectedStyles}
              filter={talentFilter}
              // actionMenu={rowMenuItems}
              columns={columns}
              setFilter={setTalentFilter}

              // onMenuClick={onListMenuClick}
              // {...tableProps}
            />
          </div>
        ) : (
          <Group
            mx={0}
            pt={"xs"}
            style={{ height: "100%", marginLeft: 0, marginRight: 0 }}
          >
            <TalentGridLayout
              filter={talentFilter}
              captures={talentData}
              selectedItems={selectedTalents}
              displayPrefs={displayPrefs}
              onAccordionChange={(val) => setDisplayPrefs({ ...displayPrefs, selectedAccordion: val })}
              // onItemClick={onItemClick}
              // onImageEvent={(type, data, originalEvent) => onItemSelected(originalEvent, data)}
              // onImageEvent={(type, val, originalEvent, isSelected) => onItemSelected(originalEvent, val,isSelected )}
              showLoading={isLoading}
              // onCaptureChange={onItemSelected}
            />
          </Group>
          // <div data={talentData} onItemClick={onItemClick} onItemSelected={onItemSelected} selectedItems={selectedTalents} />
        )}
      </Box>
      {/* </ScrollArea> */}

      {/* {filterOpen ? (
                <Box
                    style={{
                        backgroundColor: '#000',
                        opacity: '0.05',
                        position: 'absolute',
                        top: '155px',
                        right: 0,
                        bottom: 0,
                        left: '0px',
                    }}></Box>
            ) : null} */}

      {/* <Modal
        withCloseButton={true}
        size={'xl'}
        title='Create a new Talent'
        opened={talentModalOpen}
        trapFocus={true}
        onClose={() => setTalentModalOpen(false)}      >
        <TalentEdit onSubmit={(vals) => onCreateTalentSubmit(vals)} />
      </Modal> */}
    </Box>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    talent: state.talentReducer.selectedTalent,
    talents: state.talentReducer.talents,
    talentFilter: state.talentReducer.talentFilter,
    displayPrefs: state.talentReducer.displayPrefs,
    selectedTalents: state.talentReducer.selectedTalents,
    success: state.talentReducer.success,
    error: state.auth.error,
  };
};

const mapDispatchToProps = { setTalentFilter, selectTalents, setDisplayPrefs };

export default connect(mapStateToProps, mapDispatchToProps)(Talents);

const columnHelper = createColumnHelper();
const columns = [
  columnHelper.accessor("fullName", {
    header: "Name",
    cell: (info) => {
      logger.log(info);
      return (
        <Group>
          <ResolverImage
            fit={"cover"}
            height={80}
            width={70}
            src={info.row.original.latestURL}
            radius={"sm"}
          />
          <Box>
            {info.getValue()}
            <Text c={"dimmed"}>{info.row.original.code}</Text>
          </Box>
        </Group>
      );
    },
    size: 300,
  }),

  columnHelper.accessor("agency", {
    header: "Agency",
    cell: (info) => info.getValue(),
    size: 300,
  }),
  columnHelper.accessor("category", {
    header: "Category",
    cell: (info) => info.getValue(),
    size: 300,
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => info.getValue(),
    size: 120,
  }),
  columnHelper.accessor("gender", {
    header: "Gender",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("age", {
    header: "Age",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("height", {
    header: "Height",
    cell: (info) => info.getValue(),
  }),
];
